export const formatUSD = (amount: number): string =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);

export const formatTND = (amount: number): string =>
  new Intl.NumberFormat('fr-TN', { style: 'currency', currency: 'TND', minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(amount);

export const convertUsdToTnd = (usd: number, rate: number): number => Number((usd * rate).toFixed(3));

export const calculateDiscountedUsd = (unitPriceUsd: number, quantity: number, discountPct: number): number => {
  const subtotal = unitPriceUsd * quantity;
  return Number((subtotal - subtotal * (discountPct / 100)).toFixed(2));
};
